import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import api from "@/app/api";
import type { StockGroup } from "@/app/services/generated/stockgroupService";
import { stockGroupService } from "@/app/services/generated/stockgroupService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasStockGroupsCache {
  stockGroups: StockGroupsCache;
}

// Singleton cache store
const stockGroupsCacheStore = new EntityCacheStore<StockGroup>(
  EnumCacheEntityType.stockGroup,
  async () => stockGroupService.getAllStockGroups(api.tenantId)
);

// Ephemeral reader
export default class StockGroupsCache extends EntityWithGuidKeyCache<StockGroup> {
  constructor() {
    super(stockGroupsCacheStore, (x) => x.id);
  }
}
